<script lang="ts">
    import * as qs from 'qs';
    import configs from '../../config';

    let dataSetting = JSON.parse(window.localStorage.getItem('setting'))
    let pwaEnabled = !!(dataSetting && dataSetting.pwa && dataSetting.pwa.enabled)
    let pwaLoading = false

    async function onClickInstall(){
        if(pwaLoading){ return }
        pwaLoading = true
        try{
            const res = await fetch(configs.cloudapi+"/cloud/pwadomain", {
                method: 'POST',
                headers:{ 'Content-Type': 'application/x-www-form-urlencoded' },
                body: qs.stringify({})
            })
            const json = await res.json()
            if(json.statusCode==200 && json.payload && json.payload.url){
                window.location.href = json.payload.url
                return
            }else{
                alert(json.message || 'ไม่สามารถเปิดหน้าติดตั้ง PWA ได้')
            }
        }catch(err){
            alert('เกิดข้อผิดพลาด ลองใหม่อีกครั้ง')
        }
        pwaLoading = false
    }
</script>

{#if pwaEnabled}
<div class="pwa-banner" on:click={onClickInstall} role="button" tabindex="0">
    📲 {pwaLoading ? 'กำลังเปิด...' : 'ติดตั้งแอปบนมือถือ'}
</div>
{/if}

<style>
    .pwa-banner{
        display: block;
        width: 100%;
        margin: 0 auto;
        cursor: pointer;
        text-align: center;
        padding: 7px 8px;
        font-size: .72rem;
        font-weight: 500;
        color: #1a1a1a;
        background: linear-gradient(135deg,#e6c477 0%,#f4e2b8 50%,#e6c477 100%);
        box-shadow: 0 2px 6px rgba(0,0,0,.4);
        position: relative;
        z-index: 100;
        box-sizing: border-box;
    }
    /* บน desktop คอลัมน์แอปกว้าง 374px (เหมือน .container) → ให้แถบกว้างเท่ากันและอยู่กลาง */
    @media only screen and (min-device-aspect-ratio:1920 / 1080){
        .pwa-banner{ max-width: 374px; }
    }
    @media only screen and (min-device-aspect-ratio:512/683){
        .pwa-banner{ max-width: 374px; }
    }
</style>
